import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice";
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"airport transfer software",
      slug:"/airport-transfer-software"
    },
  ]
}

export default function TaxiBanner({ featureId }) {
  const dispatch = useDispatch();

  const handleOpenPopup = () => {
    dispatch(openPopup());
  };

  return (
    <section className="taxi-disbanner header-gap">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8 text-center">
            <div className="taxi-content">
              <h1 className="heading">
                <span className="gradiant-color">Airport Transfer</span>
                <span className="software-text">Software</span>
              </h1>

              <p>Smart, cloud-based airport transfer, shuttle, and taxi management software with automated scheduling, flight-tracking integration, real-time updates, and seamless dispatching-perfect for managing airport taxis, shuttles, and on-demand transfer bookings with precision and speed.</p>

              <small>21 Days Free Trial | No Credit Card Required</small>
              <Breadcrumb breadcrumbData={breadcrumbData}/>
              <div className="taxi-btn">
                <Link
                  to="#"
                  className="default-btn animated-btn"
                  onClick={handleOpenPopup}
                >
                  Book a Demo
                </Link>

                <Link to={`/features/${featureId}`} className="default-btn default-white">explore features</Link>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <img
              className="img-responsive banner-img3"
              src="assets/home/taxi-banner.webp"
              alt="Airport Transfer Banner"
            />
            <img
              className="img-responsive taxi-vector1"
              src="assets/home/taxi-vector1.webp"
              alt="Taxi Vector 1"
              loading="lazy"
            />
            <img
              className="img-responsive taxi-vector2"
              src="assets/home/taxi-vector2.webp"
              alt="Taxi Vector 2"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
